export default "__VITE_ASSET__BzfW6rfV__"